import { managedPageQueryMeta, throwIfResponseNotOk } from '@/queries/queryErrorHandling';
import { Conflict } from '@/types/Conflicten';
import { QueryFunction, useQuery } from '@tanstack/react-query';

import { useFetchWithAuth } from '../useFetchWithAuth';

type UseGetConflictenOptions = {
  throwOnHttpError?: boolean;
  suppressGlobalErrorToast?: boolean;
};

export const useGetConflicten = (refreshInterval?: number, options?: UseGetConflictenOptions) => {
  const { fetchWithAuth } = useFetchWithAuth();
  const { throwOnHttpError = false, suppressGlobalErrorToast = false } = options ?? {};
  const errorSemantics = throwOnHttpError ? 'strict-errors' : 'fallback-empty-array';

  const fetcher: QueryFunction<Conflict[]> = async ({ signal }) => {
    const response = await fetchWithAuth('/conflicten/', { signal });
    if (!response.ok && (response.status > 499 || throwOnHttpError)) {
      throwIfResponseNotOk(response, `Ophalen van conflicten is mislukt (${response.status}).`);
    }
    if (!response.ok) {
      return [];
    }
    return response.json();
  };

  return useQuery({
    queryKey: ['alleConflicten', errorSemantics],
    queryFn: fetcher,
    refetchInterval: refreshInterval,
    meta: suppressGlobalErrorToast ? managedPageQueryMeta : undefined,
  });
};
